module.exports = ".export-ptj-button-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-end;\n}"